import { ApiService } from 'src/app/services/api.service';
import { SwiperContainer } from 'swiper/element';

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TutorialComponent implements OnInit {
  @Input() tutorial = '';
  images;
  @ViewChild('swiper') swiper: ElementRef<SwiperContainer>;
  currentSlide = 0;

  constructor(private modalController: ModalController, private apiService: ApiService) {}

  ngOnInit() {
    this.getCarousel();
  }

  closeModal() {
    this.modalController.dismiss();
  }

  getCarousel() {
    if (this.tutorial) {
      this.apiService.getData('tutorial/' + this.tutorial).then(
        (res) => {
          if (!res || !res.data || res.data.length == 0) {
            this.closeModal();
          } else {
            this.images = res.data;
          }
        },
        (err) => {
          //this.presentToast('Error de conexión con el servidor. Intente nuevamente más tarde.');
          console.log(JSON.stringify(err));
          this.closeModal();
        }
      );
    } else {
      this.closeModal();
    }
  }

  previousSlide() {
    this.swiper?.nativeElement.swiper.slidePrev();
  }

  nextSlide() {
    this.swiper?.nativeElement.swiper.slideNext();
  }

  slideChanged() {
    this.currentSlide = this.swiper?.nativeElement.swiper.activeIndex;
  }
}
